import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./App.css";
import "mapbox-gl/dist/mapbox-gl.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
